import { Team } from "msd-capacity-planning-model";
import {
  FETCH_TEAMS,
  LOAD_TEAMS,
  PERSIST_TEAM,
  REMOVE_TEAM,
  TeamAction,
  TeamsState,
  SET_TEAMS_DATE_FILTER
} from "./TeamsTypes";
import { dateFilterStorage } from "../utils/dateFilterStorage";

const initialState: TeamsState = {
  items: {},
  synching: true,
  dateFilter: dateFilterStorage.get() || undefined,
};

export default function teamsReducer(
  state = initialState,
  action: TeamAction
): TeamsState {
  switch (action.type) {
    case FETCH_TEAMS:
      return {
        ...state,
        synching: true,
      };
    case REMOVE_TEAM:
      return {
        ...state,
        synching: true,
      };
    case PERSIST_TEAM:
      return {
        ...state,
        synching: true,
      };
    case LOAD_TEAMS: {
      const dateFilter = action.dateFilter || state.dateFilter;
      const filterDate = dateFilter ? new Date(dateFilter) : (() => {
        const oneYearAgo = new Date();
        oneYearAgo.setFullYear(oneYearAgo.getFullYear() - 1);
        return oneYearAgo;
      })();

      const items = action.items.reduce((all: { [id: string]: Team }, team) => {
          // Only add the team if they don't have an offboardingDate or it's after the filter date
          if (!team.offboardingDate || (
            team.offboardingDate &&
            new Date(team.offboardingDate.year, team.offboardingDate.month, team.offboardingDate.day) >= filterDate
          )) {
            all[team.id] = team;
          }
        return all;
      }, {});
      return {
        ...state,
        items,
        synching: false,
        dateFilter,
      };
    }
    case SET_TEAMS_DATE_FILTER: {
      // Save to localStorage
      dateFilterStorage.set(action.dateFilter);
      return {
        ...state,
        dateFilter: action.dateFilter,
      };
    }
    default:
      return state;
  }
}
